import useModal from 'hooks/useModal'
import { MenuSettingItem } from 'views/InhouseGame/components/styled'
import { Trans } from 'react-i18next'
import { InhouseGameDetails } from 'config/types/game'
import HotKeyModal from './HotKeyModal'

const HotKeyControl: React.FC<{
  onChangeSetting: (enable: boolean) => void
  game?: InhouseGameDetails
  value: boolean
}> = ({ value, game, onChangeSetting }) => {
  const [onPresent] = useModal(HotKeyModal)

  return (
    <MenuSettingItem
      icon="KeyboardIcon"
      active={value}
      onClick={() =>
        onPresent({
          hotKeyEnable: value,
          onHotKeyToggle: onChangeSetting,
          game,
        })
      }
    >
      <Trans>Hotkeys</Trans>
    </MenuSettingItem>
  )
}

export default HotKeyControl
